import { useParams } from "react-router-dom";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";

export const Login = () => {
    let { emailAddress, redirectUrl } = useParams<{ emailAddress: string, redirectUrl: string }>();

    var auth = React.useContext(AuthContext); 
    var decodedUrl =  decodeURIComponent(redirectUrl);
    auth.signinRedirect(emailAddress, decodedUrl);

    return <AbpnSpinner/>;

}